import React from "react";
import PriceTable from "./PriceTable";

const PrintTable = ({ items }) => {
    if (!items) {
        return null;
    }

    const headItems = items.labels;
    const bodyItems = items.prices;

    return (
        <>
            <h1
                style={{ lineHeight: "100%" }}
                className="text-3xl font-head font-bold mb-1"
            >
                Digitaal drukwerk
            </h1>
            <p className="mb-4">Snelle levering, kleinere oplages</p>
            <div className="w-full bg-white p-4 rounded border border-gray-200">
                <div className="mb-4">
                    <PriceTable
                        type="print"
                        headerItems={headItems}
                        bodyItems={bodyItems}
                    />
                </div>

                <div className="bg-blue-100 border border-blue-300 px-3 py-2 rounded mb-4">
                    <h6 className="text-xl font-bold text-blue-500">
                        Besteldeadline verstreken?
                    </h6>
                    <span className="text-blue-900">
                        Neem contact op via{" "}
                        <a
                            className="font-bold hover:underline cursor-pointer"
                            onClick={() => Intercom("show")}
                        >
                            Chat
                        </a>
                        ,{" "}
                        <a className="font-bold hover:underline" href="contact">
                            E-mail
                        </a>{" "}
                        of 088-2400240
                    </span>
                </div>
            </div>
        </>
    );
};

export default PrintTable;
